import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import TallargeLogo from "../assets/Tallarge_final_nb.png";
import TallargeWalkIcon from "../assets/tallarge_walk_64x64.gif";
import DashboardWebMockup from "../assets/dashboard_web.png";
import DashboardAppMockup from "../assets/dashboard_app.png";
import FeatureGpsVisual from "../assets/tallarge_feature_visual_gps.png";
import FeatureMessagingVisual from "../assets/tallarge_feature_visual_messaging.png";
import FeatureDispatchVisual from "../assets/tallarge_feature_visual_dispatch.png";
import FeatureCargoScanVisual from "../assets/tallarge_feature_visual_cargo_scan.png";
import SiteHeader from "./SiteHeader";

function Icon({ name, size = 18, strokeWidth = 1.8 }) {
  const common = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": true,
  };

  if (name === "arrowRight") {
    return (
      <svg {...common}>
        <path d="M5 12h14" />
        <path d="m13 6 6 6-6 6" />
      </svg>
    );
  }

  if (name === "chevronDown") {
    return (
      <svg {...common}>
        <path d="m6 9 6 6 6-6" />
      </svg>
    );
  }

  if (name === "menu") {
    return (
      <svg {...common}>
        <path d="M4 6h16M4 12h16M4 18h16" />
      </svg>
    );
  }

  if (name === "close") {
    return (
      <svg {...common}>
        <path d="m6 6 12 12M18 6 6 18" />
      </svg>
    );
  }

  if (name === "truck") {
    return (
      <svg {...common}>
        <path d="M3 6h11v10H3z" />
        <path d="M14 10h4l3 3v3h-7z" />
        <circle cx="7" cy="18" r="2" />
        <circle cx="18" cy="18" r="2" />
      </svg>
    );
  }

  if (name === "qr") {
    return (
      <svg {...common}>
        <path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4z" />
        <path d="M14 14h2M18 14h2M14 18h2M18 18h2M16 16h2M20 20h-2" />
      </svg>
    );
  }

  if (name === "package") {
    return (
      <svg {...common}>
        <path d="m12 3 8 4.5v9L12 21l-8-4.5v-9L12 3Z" />
        <path d="m4.5 7.8 7.5 4.3 7.5-4.3M12 12.1V21" />
      </svg>
    );
  }

  if (name === "message") {
    return (
      <svg {...common}>
        <path d="M20 15a3 3 0 0 1-3 3H9l-5 3v-6a3 3 0 0 1-1-2.2V7a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3z" />
        <path d="M7 9h10M7 13h6" />
      </svg>
    );
  }

  if (name === "alert") {
    return (
      <svg {...common}>
        <path d="m12 3 9 17H3L12 3Z" />
        <path d="M12 9v5M12 17h.01" />
      </svg>
    );
  }

  if (name === "mapPin") {
    return (
      <svg {...common}>
        <path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z" />
        <circle cx="12" cy="10" r="2.5" />
      </svg>
    );
  }

  if (name === "clock") {
    return (
      <svg {...common}>
        <circle cx="12" cy="12" r="8.5" />
        <path d="M12 7v5l3 2" />
      </svg>
    );
  }

  if (name === "file") {
    return (
      <svg {...common}>
        <path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9Z" />
        <path d="M14 3v6h6M8 13h8M8 17h6" />
      </svg>
    );
  }

  if (name === "check") {
    return (
      <svg {...common}>
        <path d="m5 12 4 4L19 6" />
      </svg>
    );
  }

  return null;
}

function Mark({ onClick }) {
  return (
    <a
      href="#top"
      className="mark"
      aria-label="Tallarge 首頁"
      onClick={onClick}
    >
      <img
        className="brand-logo"
        src={TallargeLogo}
        alt="Tallarge"
      />
    </a>
  );
}

function TabletShowcaseDevice() {
  return (
    <div className="tablet-device" aria-label="Tallarge 平板管理端">
      <div className="tablet-screen-frame">
        <div className="tablet-screen">
          <img
            src={DashboardWebMockup}
            alt="Tallarge 平板管理端畫面"
            draggable={false}
          />
        </div>
      </div>
    </div>
  );
}

function PhoneShowcaseDevice() {
  return (
    <div className="phone-device" aria-label="Tallarge 手機 App">
      <div className="phone-frame">
        <div className="phone-screen">
          <img
            src={DashboardAppMockup}
            alt="Tallarge 手機 App 畫面"
            draggable={false}
          />
        </div>
        <span className="showcase-phone-island" aria-hidden="true" />
      </div>
    </div>
  );
}

function ShowcaseRoute({ liveProgress }) {
  const progress = Math.min(100, Math.max(1, Number(liveProgress) || 1));
  const walkerProgress = Math.min(progress, 96);

  return (
    <div className="showcase-route" aria-hidden="true">
      <span className="showcase-route-point is-start" />
      <span className="showcase-route-point is-end" />
      <span className="showcase-route-track" />
      <span
        className="showcase-route-progress"
        style={{ width: `${progress}%` }}
      />
      <span
        className="showcase-walker"
        style={{ left: `${walkerProgress}%` }}
      >
        <img src={TallargeWalkIcon} alt="" />
      </span>
    </div>
  );
}

export default function Dashboard() {
  const [liveProgress, setLiveProgress] = useState(1);
  useEffect(() => {
    const timer = window.setTimeout(
      () => {
        setLiveProgress((progress) =>
          progress >= 100 ? 1 : progress + 1,
        );
      },
      liveProgress >= 100 ? 1000 : 1000 / 15,
    );

    return () => window.clearTimeout(timer);
  }, [liveProgress]);

  return (
    <main id="top" className="page">
      <style>{styles}</style>

      <SiteHeader />

      <section className="hero">
        <div className="hero-lighting" aria-hidden="true">
          {/* 烏雲墨色：只有這一層模糊，不影響文字和卡片 */}
          <svg
            className="hero-ink"
            viewBox="0 0 1600 1000"
            preserveAspectRatio="xMidYMid slice"
            focusable="false"
          >
            <defs>
              <filter
                id="tallarge-ink-cloud"
                x="-25%"
                y="-25%"
                width="150%"
                height="150%"
                colorInterpolationFilters="sRGB"
              >
                <feTurbulence
                  type="fractalNoise"
                  baseFrequency="0.006 0.009"
                  numOctaves="3"
                  seed="12"
                  result="noise"
                />

                <feDisplacementMap
                  in="SourceGraphic"
                  in2="noise"
                  scale="145"
                  xChannelSelector="R"
                  yChannelSelector="G"
                />

                <feGaussianBlur stdDeviation="24" />
              </filter>

              <radialGradient id="tallarge-ink-soft">
                <stop offset="0%" stopColor="#92969c" stopOpacity="0.5" />
                <stop offset="48%" stopColor="#737a85" stopOpacity="0.3" />
                <stop offset="100%" stopColor="#737a85" stopOpacity="0" />
              </radialGradient>

              <radialGradient id="tallarge-ink-dark">
                <stop offset="0%" stopColor="#101318" stopOpacity="0.8" />
                <stop offset="100%" stopColor="#101318" stopOpacity="0" />
              </radialGradient>
            </defs>

            <g filter="url(#tallarge-ink-cloud)">
              {/* 左右不對稱的墨色暈染 */}
              <ellipse
                cx="130" cy="340" rx="540" ry="310"
                fill="url(#tallarge-ink-soft)"
              />
              <ellipse
                cx="1440" cy="410" rx="540" ry="390"
                fill="url(#tallarge-ink-soft)"
              />
              <ellipse
                cx="500" cy="880" rx="650" ry="270"
                fill="url(#tallarge-ink-soft)"
                opacity="0.65"
              />
              <ellipse
                cx="1320" cy="900" rx="480" ry="260"
                fill="url(#tallarge-ink-soft)"
                opacity="0.55"
              />

              {/* 深色墨塊讓背景有疏密，不是一整片灰 */}
              <ellipse
                cx="350" cy="600" rx="370" ry="170"
                fill="url(#tallarge-ink-dark)"
              />
              <ellipse
                cx="1210" cy="640" rx="400" ry="200"
                fill="url(#tallarge-ink-dark)"
              />
              <ellipse
                cx="850" cy="60" rx="600" ry="330"
                fill="url(#tallarge-ink-dark)"
              />
            </g>
          </svg>

          {/* 左右光束獨立運動 */}
          <div className="hero-spotlight hero-spotlight-left">
            <div className="hero-spotlight-beam" />
          </div>

          <div className="hero-spotlight hero-spotlight-right">
            <div className="hero-spotlight-beam" />
          </div>

          <div className="hero-lighting-fade" />
        </div>

        <div className="wrap hero-content">
          <div className="hero-showcase-layout">
            <div className="hero-device-side hero-device-tablet">
              <TabletShowcaseDevice />
            </div>

            <div className="hero-message">
              <h1>
                連結每一趟
                <br />
                <span>值得信賴的旅程</span>
              </h1>

            </div>

            <div className="hero-device-side hero-device-phone">
              <PhoneShowcaseDevice />
            </div>
          </div>

          <div className="hero-product">
            <ShowcaseRoute liveProgress={liveProgress} />
          </div>

          <a className="scroll-link" href="#manage">
            向下探索 <span />
          </a>
        </div>
      </section>

      <section id="manage" className="management-section feature-page feature-intro-page">
        <div className="management-geometry" aria-hidden="true">
          <div className="management-cube">
            <div className="management-cube-space">
              <span className="management-cube-plane management-cube-back" />
              <span className="management-cube-plane management-cube-left" />
              <span className="management-cube-plane management-cube-right" />
              <span className="management-cube-plane management-cube-floor" />
              <span className="management-cube-plane management-cube-ceiling" />
              <span className="management-cube-runner management-cube-runner-one" />
              <span className="management-cube-runner management-cube-runner-two" />
              <span className="management-cube-runner management-cube-runner-three" />
              <span className="management-cube-runner management-cube-runner-four" />
            </div>
          </div>
        </div>
        <div className="wrap feature-page-inner">
          <div className="management-copy">
            <h2>
              化繁為簡，
              <br />
              一目了然。
            </h2>
          </div>
        </div>
      </section>

      <section id="gps-tracking" className="feature-page feature-detail-page">
        <div className="wrap feature-page-inner feature-detail-layout">
          <div className="feature-detail-copy">
            <h2>GPS 追蹤</h2>
            <p>即時掌握車輛位置與配送進度，讓每一趟運送都清楚可見。</p>
          </div>
          <img
            className="feature-page-visual"
            src={FeatureGpsVisual}
            alt="GPS 追蹤"
            draggable={false}
          />
        </div>
      </section>

      <section id="cargo-scan" className="feature-page feature-detail-page feature-detail-alt">
        <div className="wrap feature-page-inner feature-detail-layout is-reversed">
          <div className="feature-detail-copy">
            <h2>貨物掃描</h2>
            <p>用手機相機掃描 QR Code，快速確認貨物資訊與入庫狀態。</p>
          </div>
          <img
            className="feature-page-visual"
            src={FeatureCargoScanVisual}
            alt="貨物掃描"
            draggable={false}
          />
        </div>
      </section>

      <section id="dispatch" className="feature-page feature-detail-page">
        <div className="wrap feature-page-inner feature-detail-layout">
          <div className="feature-detail-copy">
            <h2>派單</h2>
            <p>整合訂單、車輛與路線，讓每一次派送都更準確、更有效率。</p>
          </div>
          <img
            className="feature-page-visual"
            src={FeatureDispatchVisual}
            alt="派單"
            draggable={false}
          />
        </div>
      </section>

      <section id="messaging" className="feature-page feature-detail-page feature-detail-alt">
        <div className="wrap feature-page-inner feature-detail-layout is-reversed">
          <div className="feature-detail-copy">
            <h2>即時通訊</h2>
            <p>串聯司機、倉庫與客服團隊，讓重要訊息即時抵達每個人。</p>
          </div>
          <img
            className="feature-page-visual"
            src={FeatureMessagingVisual}
            alt="即時通訊"
            draggable={false}
          />
        </div>
      </section>

      <section id="night" className="night-section">
        <div className="night-image" />
        <div className="night-overlay" />

        <div className="wrap night-content">
          <h2>
            24 小時，
            <br />
            <span>星海亦通明。
            </span>
          </h2>

          <div className="night-route">
            <i />
            <span />
            <span />
            <span />
            <span />
          </div>

          <div className="night-actions">
            <Link className="apple-button light" to="/about">
              認識 Tallarge <Icon name="arrowRight" size={17} />
            </Link>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="wrap footer-inner">
          <Mark />
          <span>連結每一趟值得信賴的旅程</span>
          <small>© 2026 Tallarge</small>
        </div>
      </footer>
    </main>
  );
}

const styles = `
:root {
  --orange: #ff7a00;
  --ink: #1d1d1f;
  --sub: #6e6e73;
  --paper: #fbfbfd;
  --line: #d2d2d7;
  --navy: #07152f;
  --ease: cubic-bezier(.23, 1, .32, 1);
}

* {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  background: var(--paper);
  color: var(--ink);
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display",
    "SF Pro Text", "PingFang TC", "Microsoft JhengHei", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
}

a {
  color: inherit;
  text-decoration: none;
}

button {
  font: inherit;
  border: 0;
}

.page {
  overflow: clip;
  background: #fff;
}

.wrap {
  width: min(1180px, calc(100% - 48px));
  margin: 0 auto;
}

/* ==============================
   導覽列
   ============================== */

.header {
  height: 60px;
  position: sticky;
  top: 0;
  z-index: 20;
  background: rgba(251, 251, 253, .82);
  backdrop-filter: saturate(180%) blur(18px);
  border-bottom: 1px solid rgba(0, 0, 0, .06);
}

.nav {
  height: 100%;
  display: flex;
  align-items: center;
  gap: 24px;
}

.mark {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  height: 100%;
}

.brand-logo {
  display: block;
  width: 150px;
  height: auto;
  max-height: 38px;
  object-fit: contain;
  object-position: left center;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 22px;
  margin-left: auto;
}

.nav-links a {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  color: #3b3b3f;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  transition: color .2s var(--ease);
}

.nav-links a:hover {
  color: var(--orange);
}

.nav-actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 13px;
}

.language {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 6px;
  background: transparent;
  color: #515157;
  font-size: 12px;
  white-space: nowrap;
  cursor: pointer;
}

.nav-login {
  padding: 8px 13px;
  border: 1px solid #c8c8cd;
  border-radius: 980px;
  background: white;
  color: #1d1d1f;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: all .2s var(--ease);
}

.nav-login:hover {
  border-color: #1d1d1f;
  background: #1d1d1f;
  color: white;
}

.nav-menu {
  display: none;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  background: transparent;
  color: #1d1d1f;
  cursor: pointer;
}

.nav a:focus-visible,
.nav button:focus-visible {
  outline: 2px solid var(--orange);
  outline-offset: 4px;
}

/* ==============================
   首屏：同時依視窗寬度與高度調整
   ============================== */

.hero {
  position: relative;
  min-height: calc(100svh - 60px);
  display: flex;
  align-items: center;
  isolation: isolate;
  overflow: hidden;
  background: #202328;
}

/* =========================================
   首屏背景：柔和橘藍光暈＋雙側動態聚光
   ========================================= */

.hero {
  background: #f7f8fb;
}

/* ========================================
   雙側聚光修正版
   加在 const styles 最底部
   ======================================== */

.hero > .hero-lighting {
  /* 可以從這裡微調整體效果 */
  --ink-opacity: 0.78;
  --ink-blur: 12px;
  --beam-opacity: 0.35;
  --beam-blur: 28px;

  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  isolation: isolate;
  pointer-events: none;
  user-select: none;

  background:
    radial-gradient(
      ellipse at 50% 52%,
      rgba(116, 122, 132, 0.15) 0%,
      transparent 68%
    ),
    #202328;
}


/* 底層色彩保持柔和，不跟光束搶焦點 */
.hero .hero-ambient {
  top: -12%;
  height: 85%;
  filter: blur(70px);
}

/*
 * 光束固定從左右上方射入。
 * 使用較窄的扇形，保留清楚的照射方向。
 */
.hero .hero-spotlight {
  top: -32px;
  width: 112%;
  height: clamp(380px, 40vw, 680px);
  transform-origin: 0 0;
  opacity: var(--beam-opacity);
  filter: blur(var(--beam-blur));
}

.hero .hero-spotlight-left {
  left: -8%;
  transform: rotate(-5deg);
  animation: tallarge-light-sweep-left 9s ease-in-out infinite;
  animation-delay: -2s;
}

.hero .hero-spotlight-right {
  left: 108%;
  transform: scaleX(-1) rotate(5deg);
  animation: tallarge-light-sweep-right 11s ease-in-out infinite;
  animation-delay: -6s;
}

.hero .hero-spotlight-beam {
  inset: 0;

  clip-path: polygon(
    0% 0%,
    100% 32%,
    100% 66%
  );

  -webkit-mask-image: linear-gradient(
    90deg,
    #000 0%,
    #000 35%,
    rgba(0, 0, 0, 0.85) 55%,
    rgba(0, 0, 0, 0.25) 82%,
    transparent 100%
  );

  mask-image: linear-gradient(
    90deg,
    #000 0%,
    #000 35%,
    rgba(0, 0, 0, 0.85) 55%,
    rgba(0, 0, 0, 0.25) 82%,
    transparent 100%
  );
}

/* 左：暖白光 */
.hero .hero-spotlight-left .hero-spotlight-beam {
  background: linear-gradient(
    100deg,
    #fff6e8 0%,
    #fffaf3 18%,
    rgba(255, 255, 255, 0.98) 43%,
    rgba(255, 247, 234, 0.65) 70%,
    rgba(255, 247, 234, 0) 100%
  );
}

/* 右：冷白光 */
.hero .hero-spotlight-right .hero-spotlight-beam {
  background: linear-gradient(
    100deg,
    #eaf6ff 0%,
    #f4faff 18%,
    rgba(255, 255, 255, 0.98) 43%,
    rgba(233, 246, 255, 0.65) 70%,
    rgba(233, 246, 255, 0) 100%
  );
}

/*
 * 擴大擺動角度。
 * 只旋轉背景光束，不移動文字與卡片。
 */
@keyframes tallarge-light-sweep-left {
  0%,
  100% {
    transform: rotate(-5deg);
  }

  50% {
    transform: rotate(13deg);
  }
}

@keyframes tallarge-light-sweep-right {
  0%,
  100% {
    transform: scaleX(-1) rotate(9deg);
  }

  50% {
    transform: scaleX(-1) rotate(-8deg);
  }
}

/* 移除原本中心的白色遮罩，避免蓋掉光束 */
.hero .hero-lighting-fade {
  position: absolute;
  inset: 0;
  pointer-events: none;

  /* 改成深藍收尾，不再覆蓋白色 */
  background: linear-gradient(
    180deg,
    rgba(16, 23, 43, 0) 40%,
    rgba(16, 23, 43, 0.2) 72%,
    #10172b 100%
  );
}

/* 手機保留方向感，控制模糊範圍 */
@media (max-width: 620px) {
  .hero > .hero-lighting {
    --ambient-opacity: 0.36;
    --beam-opacity: 0.85;
    --beam-blur: 11px;
  }

  .hero .hero-ambient {
    filter: blur(40px);
  }

  .hero .hero-spotlight {
    top: -20px;
    width: 135%;
    height: 330px;
  }

  .hero .hero-spotlight-left {
    left: -15%;
  }

  .hero .hero-spotlight-right {
    left: 115%;
  }
}

/* 尊重系統「減少動態效果」設定 */
@media (prefers-reduced-motion: reduce) {
  .hero .hero-spotlight {
    animation: none !important;
  }
}

.hero > .hero-content {
  position: relative;
  z-index: 1;
}

/* -------------------------
   底層：低飽和柔和光暈
   ------------------------- */


.hero .hero-ink {
  position: absolute;
  inset: -6%;
  width: 112%;
  height: 112%;
  display: block;
  z-index: 0;

  opacity: var(--ink-opacity);
  filter: blur(var(--ink-blur));
}

.hero-ambient {
  position: absolute;
  top: -8%;
  width: 70%;
  height: 92%;
  border-radius: 50%;
  opacity: var(--ambient-opacity);
  filter: blur(65px);
}

.hero-ambient-left {
  left: -26%;

  background: radial-gradient(
    ellipse at center,
    rgba(255, 181, 116, 0.7) 0%,
    rgba(255, 203, 160, 0.46) 34%,
    rgba(255, 225, 201, 0.18) 55%,
    rgba(255, 225, 201, 0) 74%
  );
}

.hero-ambient-right {
  right: -26%;

  background: radial-gradient(
    ellipse at center,
    rgba(134, 190, 241, 0.66) 0%,
    rgba(176, 211, 247, 0.44) 34%,
    rgba(211, 231, 252, 0.18) 55%,
    rgba(211, 231, 252, 0) 74%
  );
}

/* -------------------------
   中層：左右兩道光束

   外層負責模糊與旋轉，
   內層負責光束形狀。
   ------------------------- */

.hero .hero-spotlight {
  position: absolute;
  top: -45px;
  z-index: 1;

  width: 118%;
  height: clamp(480px, 48vw, 820px);

  transform-origin: 0 0;
  opacity: var(--beam-opacity);
  filter: blur(var(--beam-blur));
}

/* 光源由左右畫面外射入 */
.hero .hero-spotlight-left {
  left: -9%;
  animation: tallarge-cloud-light-left 14s ease-in-out infinite;
  animation-delay: -3s;
}

.hero .hero-spotlight-right {
  left: 109%;
  animation: tallarge-cloud-light-right 17s ease-in-out infinite;
  animation-delay: -8s;
}

.hero .hero-spotlight-beam {
  position: absolute;
  inset: 0;

  /* 寬幅扇形，避免變成細長亮線 */
  clip-path: polygon(
    0% 0%,
    100% 8%,
    100% 95%
  );

  /* 越接近遠端越淡 */
  -webkit-mask-image: linear-gradient(
    90deg,
    #000 0%,
    #000 22%,
    rgba(0, 0, 0, 0.75) 48%,
    rgba(0, 0, 0, 0.25) 75%,
    transparent 100%
  );

  mask-image: linear-gradient(
    90deg,
    #000 0%,
    #000 22%,
    rgba(0, 0, 0, 0.75) 48%,
    rgba(0, 0, 0, 0.25) 75%,
    transparent 100%
  );
}

/* 左：微暖的銀白光 */
.hero .hero-spotlight-left .hero-spotlight-beam {
  background: linear-gradient(
    105deg,
    rgba(255, 238, 211, 0.95) 0%,
    rgba(244, 231, 213, 0.75) 28%,
    rgba(228, 225, 220, 0.32) 62%,
    rgba(228, 225, 220, 0) 100%
  );
}

/* 右：低飽和的冷銀光 */
.hero .hero-spotlight-right .hero-spotlight-beam {
  background: linear-gradient(
    105deg,
    rgba(226, 236, 247, 0.95) 0%,
    rgba(212, 225, 239, 0.75) 28%,
    rgba(201, 213, 228, 0.32) 62%,
    rgba(201, 213, 228, 0) 100%
  );
}

/* 週期錯開，避免左右像鏡像一樣同步 */
@keyframes tallarge-cloud-light-left {
  0%, 100% {
    transform: rotate(-6deg);
  }

  50% {
    transform: rotate(8deg);
  }
}

@keyframes tallarge-cloud-light-right {
  0%, 100% {
    transform: scaleX(-1) rotate(7deg);
  }

  50% {
    transform: scaleX(-1) rotate(-7deg);
  }
}

/* =========================================
   上層：局部壓暗與底部收邊
   水墨層負責紋理，這層只整理明暗
   ========================================= */

.hero .hero-lighting-fade {
  position: absolute;
  inset: 0;
  z-index: 2;
  pointer-events: none;

  background:
    radial-gradient(
      ellipse at 50% 18%,
      rgba(22, 25, 30, 0.24) 0%,
      transparent 55%
    ),
    linear-gradient(
      180deg,
      rgba(32, 35, 40, 0) 52%,
      rgba(32, 35, 40, 0.3) 80%,
      #202328 100%
    );
}

/* 深色背景上的文字 */
.hero .hero-content h1 {
  color: #f5f2eb;
}

/* 原本的 .hero h1 span 橘色規則繼續保留 */

.hero .scroll-link {
  color: #b6bcc5;
}

/* =========================================
   手機
   ========================================= */

@media (max-width: 620px) {
  .hero > .hero-lighting {
    --ink-opacity: 0.65;
    --ink-blur: 10px;
    --beam-opacity: 0.3;
    --beam-blur: 20px;
  }

  .hero .hero-spotlight {
    top: -25px;
    width: 150%;
    height: 480px;
  }

  .hero .hero-spotlight-left {
    left: -25%;
  }

  .hero .hero-spotlight-right {
    left: 125%;
  }
}

/* 減少動態效果時，保留靜態照射角度 */
@media (prefers-reduced-motion: reduce) {
  .hero .hero-spotlight {
    animation: none;
  }

  .hero .hero-spotlight-left {
    transform: rotate(1deg);
  }

  .hero .hero-spotlight-right {
    transform: scaleX(-1) rotate(1deg);
  }
}
  
.hero-content {
  padding-top: clamp(20px, 4svh, 56px);
  padding-bottom: clamp(18px, 3svh, 40px);
  text-align: center;
}

.overline {
  margin: 0;
  color: #6e6e73;
  font-size: 13px;
  font-weight: 650;
  letter-spacing: .04em;
}

.overline.orange {
  color: #c85b00;
}

.hero h1,
.management-copy h2,
.product-intro h2,
.night-content h2 {
  margin: 11px auto 0;
  letter-spacing: -.065em;
  font-weight: 700;
  line-height: 1.06;
  text-wrap: balance;
}

.hero h1 {
  max-width: 920px;
  margin-top: 0;
  font-size: clamp(36px, min(6.15vw, 9svh), 84px);
  letter-spacing: -.075em;
  line-height: 1.01;
}

.hero h1 span {
  color: var(--orange);
}

.hero-copy {
  max-width: 520px;
  margin: 26px auto 0;
  color: #515154;
  font-size: clamp(16px, 1.45vw, 19px);
  letter-spacing: -.025em;
  line-height: 1.58;
  text-wrap: balance;
}

.hero-actions,
.night-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 28px;
}

.hero-actions {
  margin-top: clamp(16px, 2.8svh, 28px);
}

.apple-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 42px;
  padding: 0 17px;
  border-radius: 980px;
  font-size: 14px;
  font-weight: 550;
  cursor: pointer;
  transition:
    transform .2s var(--ease),
    box-shadow .2s var(--ease),
    background .2s var(--ease);
}

.apple-button:active {
  transform: scale(.97);
}

.apple-button.dark {
  background: #1d1d1f;
  color: #fff;
}

.apple-button.dark:hover {
  transform: translateY(-2px);
  box-shadow: 0 11px 22px rgba(0, 0, 0, .16);
}

.hero-product {
  width: min(1480px, 100%);
  margin: clamp(14px, 2.1svh, 30px) auto 0;
}

.scroll-link {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  margin-top: clamp(14px, 2.4svh, 29px);
  color: #6e6e73;
  font-size: 12px;
}

.scroll-link span {
  width: 6px;
  height: 6px;
  border-right: 1px solid #6e6e73;
  border-bottom: 1px solid #6e6e73;
  transform: rotate(45deg);
  animation: down 1.8s ease-in-out infinite;
}

@keyframes down {
  50% {
    transform: translateY(4px) rotate(45deg);
    opacity: .45;
  }
}

/* ==============================
   首屏：平板管理端、手機 App 與行進 GIF
   ============================== */
.hero-showcase-layout {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1.65fr) minmax(96px, .75fr);
  grid-template-areas:
    "message message"
    "tablet phone";
  align-items: center;
  gap: clamp(18px, 3svh, 28px) clamp(10px, 3vw, 28px);
  width: 100%;
  max-width: 1080px;
  margin: 0 auto;
}

.hero-showcase-layout::before {
  position: absolute;
  z-index: 0;
  inset: 6% 7% 10%;
  background: radial-gradient(ellipse at center, rgba(255, 255, 255, .12), transparent 70%);
  filter: blur(32px);
  content: "";
  pointer-events: none;
}

.hero-showcase-layout > * {
  position: relative;
  z-index: 1;
}

.hero-message {
  grid-area: message;
  width: 100%;
  text-align: center;
}

.hero-device-side {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
}

.hero-device-tablet {
  grid-area: tablet;
}

.hero-device-phone {
  grid-area: phone;
}

.tablet-device {
  display: flex;
  flex: 0 1 auto;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: auto;
  min-width: 0;
}

.tablet-screen-frame {
  width: min(100%, 68vw, 740px, calc(44svh * 1.7778));
  aspect-ratio: 16 / 9;
  padding: clamp(8px, .75vw, 12px);
  border: 1px solid rgba(0, 0, 0, .72);
  border-radius: clamp(14px, 1.2vw, 22px);
  background: linear-gradient(145deg, #454952 0%, #17191d 42%, #30343a 100%);
  box-shadow: 0 24px 54px rgba(0, 0, 0, .34);
}

.tablet-screen {
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: clamp(8px, .7vw, 13px);
  background: #fff;
}

.tablet-screen img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  user-select: none;
}

.phone-device {
  flex: 0 0 auto;
  width: min(100%, clamp(142px, 17vw, 196px));
  height: auto;
  aspect-ratio: 706 / 1466;
}

.phone-frame {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 6px;
  border: 1px solid rgba(0, 0, 0, .72);
  border-radius: 32px;
  background: linear-gradient(145deg, #454952, #15171b 45%, #30343a);
  box-shadow: 0 25px 58px rgba(0, 0, 0, .34);
}

.phone-screen {
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 25px;
  background: #fff;
}

.phone-screen img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  user-select: none;
}

.showcase-phone-island {
  position: absolute;
  z-index: 2;
  top: 11px;
  left: 50%;
  width: 34%;
  height: 13px;
  border-radius: 999px;
  background: #111216;
  transform: translateX(-50%);
  pointer-events: none;
}

.showcase-route {
  position: relative;
  width: min(900px, calc(100% - 100px));
  height: 48px;
  margin: clamp(14px, 2.1svh, 23px) auto 0;
}

.showcase-route-point {
  position: absolute;
  z-index: 1;
  top: 50%;
  width: 10px;
  height: 10px;
  border: 2px solid rgba(255, 255, 255, .92);
  border-radius: 50%;
  background: #ff9b42;
  box-shadow: 0 0 0 5px rgba(255, 155, 66, .18);
  transform: translateY(-50%);
}

.showcase-route-point.is-start {
  left: 0;
}

.showcase-route-point.is-end {
  right: 0;
  background: #75a9ee;
  box-shadow: 0 0 0 5px rgba(117, 169, 238, .18);
}

.showcase-route-track,
.showcase-route-progress {
  position: absolute;
  top: 50%;
  left: 5px;
  height: 3px;
  border-radius: 999px;
  transform: translateY(-50%);
}

.showcase-route-track {
  right: 5px;
  background: repeating-linear-gradient(90deg, rgba(255, 255, 255, .28) 0 6px, transparent 6px 13px);
}

.showcase-route-progress {
  max-width: calc(100% - 10px);
  background: linear-gradient(90deg, #ffad5c, #ff7a00 58%, #77aaf0);
  box-shadow: 0 0 12px rgba(255, 145, 55, .4);
  transition: width .55s cubic-bezier(.23, 1, .32, 1);
}

.showcase-walker {
  position: absolute;
  z-index: 2;
  top: 50%;
  display: grid;
  width: 52px;
  height: 52px;
  place-items: center;
  transform: translate(-50%, -50%);
  transition: left .55s cubic-bezier(.23, 1, .32, 1);
}

.showcase-walker img {
  display: block;
  width: 48px;
  height: 48px;
  object-fit: contain;
  filter: drop-shadow(0 4px 6px rgba(0, 0, 0, .2));
}

@keyframes tallarge-tablet-yaw {
  from { transform: perspective(1000px) rotateY(15deg); }
  to { transform: perspective(1000px) rotateY(30deg); }
}

@keyframes tallarge-phone-yaw {
  from { transform: perspective(1000px) rotateY(-15deg); }
  to { transform: perspective(1000px) rotateY(-30deg); }
}

@media (prefers-reduced-motion: reduce) {
  .showcase-route-progress,
  .showcase-walker {
    transition: none;
  }
}

@media (min-width: 1280px) {
  .hero {
    height: calc(100vh - 60px);
    height: calc(100dvh - 60px);
    min-height: 0;
  }

  .hero > .wrap.hero-content {
    width: min(1680px, calc(100% - 80px));
    height: 100%;
    align-self: stretch;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    padding-top: clamp(12px, 2svh, 24px);
    padding-bottom: clamp(8px, 1.4svh, 16px);
  }

  .hero-showcase-layout {
    display: block;
    flex: 0 0 auto;
    height: max(420px, min(580px, calc(100dvh - 240px)));
    max-width: none;
    min-height: 0;
  }

  .hero-message {
    position: absolute;
    top: 0;
    left: 50%;
    z-index: 3;
    width: min(620px, 100%);
    transform: translateX(-50%);
  }

  .hero-device-tablet {
    position: absolute;
    top: clamp(120px, 19svh, 170px);
    left: clamp(24px, 8vw, 128px);
    width: min(42vw, 680px, calc(42svh * 1.7778));
  }

  .hero-device-tablet .tablet-device,
  .hero-device-tablet .tablet-screen-frame {
    width: 100%;
  }

  .hero-device-tablet .tablet-device {
    transform: perspective(1000px) rotateY(15deg);
    animation: tallarge-tablet-yaw 8s ease-in-out infinite alternate;
    will-change: transform;
  }

  .hero-device-phone {
    position: absolute;
    top: clamp(24px, 4svh, 36px);
    right: clamp(80px, 10vw, 180px);
    width: min(100%, clamp(170px, min(16vw, 29svh), 250px));
  }

  .hero-device-phone .phone-device {
    width: 100%;
    transform: perspective(1000px) rotateY(-15deg);
    animation: tallarge-phone-yaw 8s ease-in-out infinite alternate;
    will-change: transform;
  }

  .hero-device-tablet,
  .hero-device-phone {
    isolation: isolate;
  }

  .hero-device-tablet::after,
  .hero-device-phone::after {
    position: absolute;
    z-index: -1;
    right: 10%;
    bottom: -26px;
    left: 10%;
    height: 56px;
    border-radius: 50%;
    background: radial-gradient(ellipse at 50% 0%, rgba(255, 231, 194, .2) 0%, rgba(255, 184, 112, .12) 38%, rgba(255, 151, 76, .045) 64%, transparent 82%);
    filter: blur(12px);
    opacity: .78;
    content: "";
    pointer-events: none;
  }

  .hero-device-phone::after {
    right: 14%;
    bottom: -22px;
    left: 14%;
    height: 46px;
    opacity: .68;
    filter: blur(10px);
  }

  .hero .hero-product {
    width: min(1480px, 100%);
    margin-top: 0;
    flex: 0 0 auto;
  }

  .showcase-route {
    width: min(1160px, calc(100% - 160px));
    height: 36px;
    margin-top: 0;
  }

  .hero .scroll-link {
    align-self: center;
    margin-top: 6px;
  }
}

@media (min-width: 1280px) and (prefers-reduced-motion: reduce) {
  .hero-device-tablet .tablet-device {
    animation: none;
    transform: perspective(1000px) rotateY(15deg);
  }

  .hero-device-phone .phone-device {
    animation: none;
    transform: perspective(1000px) rotateY(-15deg);
  }
}

/* ==============================
   車行管理與手機展示
   ============================== */

.management-section {
  position: relative;
  isolation: isolate;
  padding: clamp(64px, 12svh, 160px) 0;
  overflow: hidden;
  background: #f4f7fa;
}

.management-section > .feature-page-inner {
  position: relative;
  z-index: 2;
}

.management-geometry {
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;
  perspective: 1000px;
  background-color: #fff;
  background-image:
    linear-gradient(rgba(7, 21, 47, .075) 1px, transparent 1px),
    linear-gradient(90deg, rgba(7, 21, 47, .075) 1px, transparent 1px);
  background-size: 76px 76px;
  -webkit-mask-image: radial-gradient(
    ellipse at center,
    #000 0 68%,
    transparent 100%
  );
  mask-image: radial-gradient(
    ellipse at center,
    #000 0 68%,
    transparent 100%
  );
}

.management-cube {
  position: absolute;
  inset: -18%;
  opacity: .86;
}

.management-cube-space {
  position: absolute;
  inset: 0;
  transform: rotateX(5deg) rotateY(-7deg) rotateZ(0deg);
  transform-style: preserve-3d;
}

.management-cube-plane {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 1px solid rgba(7, 21, 47, .16);
  background-color: rgba(244, 247, 250, .25);
  background-image:
    linear-gradient(rgba(7, 21, 47, .12) 1px, transparent 1px),
    linear-gradient(90deg, rgba(7, 21, 47, .12) 1px, transparent 1px);
  background-size: 70px 70px;
  backface-visibility: visible;
}

.management-cube-back { transform: translateZ(-520px); }
.management-cube-left { transform: rotateY(90deg) translateZ(520px); }
.management-cube-right { transform: rotateY(-90deg) translateZ(520px); }
.management-cube-floor { transform: rotateX(90deg) translateZ(360px); }
.management-cube-ceiling { transform: rotateX(-90deg) translateZ(360px); }

.management-cube-runner {
  position: absolute;
  z-index: 1;
  width: 76px;
  height: 2px;
  border-radius: 999px;
  background: linear-gradient(90deg, transparent, rgba(255, 122, 0, .28) 20%, rgba(255, 122, 0, .58) 50%, rgba(255, 122, 0, .28) 80%, transparent);
  opacity: .56;
  box-shadow: 0 0 5px rgba(255, 122, 0, .28);
  transform-origin: center;
  offset-rotate: auto;
}

.management-cube-runner-one {
  left: 19%; top: 30%;
  offset-path: path("M 0 0 L 152 0 L 152 152 L 456 152 L 456 304");
  animation: management-cube-travel-one 9s linear infinite;
}

.management-cube-runner-two {
  left: 63%; top: 20%;
  offset-path: path("M 0 0 L 0 152 L -228 152 L -228 380 L -76 380");
  animation: management-cube-travel-two 10s linear 1s infinite;
}

.management-cube-runner-three {
  left: 24%; top: 68%;
  offset-path: path("M 0 0 L 228 0 L 228 -152 L 532 -152");
  animation: management-cube-travel-three 11s linear 1.6s infinite;
}

.management-cube-runner-four {
  left: 73%; top: 52%;
  offset-path: path("M 0 0 L -152 0 L -152 228 L -456 228");
  animation: management-cube-travel-four 12s linear 2.2s infinite;
}

@keyframes management-cube-travel-one {
  from { offset-distance: 0%; }
  to { offset-distance: 100%; }
}
@keyframes management-cube-travel-two {
  from { offset-distance: 0%; }
  to { offset-distance: 100%; }
}
@keyframes management-cube-travel-three {
  from { offset-distance: 0%; }
  to { offset-distance: 100%; }
}
@keyframes management-cube-travel-four {
  from { offset-distance: 0%; }
  to { offset-distance: 100%; }
}

.management-grid {
  display: grid;
  grid-template-columns: .78fr 1.22fr;
  align-items: center;
  gap: 82px;
}

.management-copy > p:not(.overline) {
  max-width: 410px;
  margin: 24px 0 0;
  color: #5c5c61;
  font-size: 16px;
  line-height: 1.72;
  letter-spacing: -.012em;
  text-wrap: balance;
}

.management-copy h2 {
  margin-top: 0;
  font-size: clamp(48px, 5.35vw, 76px);
  letter-spacing: -.085em;
}

.management-copy .management-slogan {
  position: relative;
  max-width: 350px;
  margin-top: 34px;
  padding-left: 18px;
  color: #2d3440;
  font-size: clamp(22px, 2.25vw, 31px);
  font-weight: 650;
  line-height: 1.45;
  letter-spacing: -.055em;
}

.management-copy .management-slogan::before {
  content: "";
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: 0;
  width: 3px;
  border-radius: 999px;
  background: linear-gradient(180deg, #ffb36b, var(--orange));
}

.product-stage {
  position: relative;
  min-height: 700px;
  margin-top: 0;
  overflow: hidden;
  background:
    radial-gradient(circle at 50% 37%, #364f86 0, transparent 27%),
    linear-gradient(135deg, #07142f, #0e254d 58%, #08152e);
  border-radius: 44px;
}

.product-stage:after {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image: radial-gradient(
    rgba(255, 255, 255, .22) .65px,
    transparent .8px
  );
  background-size: 17px 17px;
  opacity: .15;
  mask-image: linear-gradient(to bottom, black, transparent 82%);
}

.product-stage-glow {
  position: absolute;
  top: 76px;
  left: 50%;
  width: 460px;
  height: 460px;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    color-mix(in srgb, var(--feature-accent) 44%, transparent),
    rgba(255, 141, 49, 0) 67%
  );
  filter: blur(10px);
  transform: translateX(-50%);
  transition: background .35s var(--ease);
}

.product-feature {
  position: absolute;
  z-index: 4;
  display: flex;
  align-items: center;
  gap: 11px;
  width: 190px;
  padding: 11px 12px;
  border: 1px solid transparent;
  border-radius: 16px;
  background: transparent;
  color: #fff;
  text-align: left;
  cursor: pointer;
  transition:
    transform .25s var(--ease),
    background .25s var(--ease),
    border-color .25s var(--ease);
}

.product-feature:hover {
  transform: translateY(-3px);
}

.product-feature.active {
  border-color: rgba(255, 255, 255, .2);
  background: rgba(255, 255, 255, .11);
  backdrop-filter: blur(9px);
  transform: translateY(-2px);
}

.feature-icon {
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  width: 38px;
  height: 38px;
  border: 1px solid rgba(255, 255, 255, .2);
  border-radius: 12px;
  background: rgba(255, 255, 255, .1);
  color: var(--feature-accent);
  transition:
    color .25s var(--ease),
    background .25s var(--ease);
}

.product-feature.active .feature-icon {
  background: rgba(255, 255, 255, .94);
  color: var(--feature-accent);
}

.feature-copy {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.feature-copy b {
  font-size: 13px;
  letter-spacing: -.02em;
}

.feature-copy small {
  color: rgba(255, 255, 255, .55);
  font-size: 10px;
}

.feature-0 {
  top: 194px;
  left: calc(50% - 340px);
}

.feature-1 {
  top: 318px;
  right: calc(50% - 350px);
}

.feature-2 {
  bottom: 151px;
  left: calc(50% - 340px);
}

.feature-3 {
  bottom: 208px;
  right: calc(50% - 350px);
}

.phone-shell {
  position: absolute;
  z-index: 5;
  bottom: -120px;
  left: 50%;
  width: 302px;
  height: 590px;
  padding: 11px;
  border: 6px solid #050509;
  border-radius: 45px;
  background: #111116;
  box-shadow: 0 45px 80px rgba(0, 0, 0, .43);
  transform: translateX(-50%);
}

.phone-island {
  position: absolute;
  z-index: 5;
  top: 18px;
  left: 50%;
  width: 92px;
  height: 23px;
  border-radius: 14px;
  background: #050509;
  transform: translateX(-50%);
}

.phone-view {
  position: relative;
  height: 100%;
  overflow: hidden;
  border-radius: 30px;
  background: #f7f8fb;
  color: #1d1d1f;
  padding: 0;
}

.phone-feature-art {
  position: absolute;
  z-index: 1;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.phone-feature-art-previous {
  z-index: 1;
  animation: phone-feature-fade-out .56s cubic-bezier(.4, 0, .8, 1) forwards;
}

.phone-feature-art-current {
  z-index: 2;
  animation: phone-feature-fade-in .56s cubic-bezier(.2, .8, .2, 1) both;
}

@keyframes phone-feature-fade-out {
  0% { opacity: 1; filter: brightness(1); }
  38% { opacity: .28; filter: brightness(.48) saturate(.7); }
  100% { opacity: 0; filter: brightness(.35) saturate(.55); }
}

@keyframes phone-feature-fade-in {
  0% { opacity: 0; filter: brightness(.48) saturate(.7); }
  55% { opacity: .78; filter: brightness(.92) saturate(.95); }
  100% { opacity: 1; filter: brightness(1) saturate(1); }
}


/* ==============================
   產品體驗
   ============================== */

.product-section {
  padding: clamp(64px, 12svh, 160px) 0 0;
  background: #fff;
}

.product-intro {
  text-align: center;
}

.product-intro h2 {
  font-size: clamp(41px, 4.7vw, 63px);
}

.product-intro > p:last-child {
  max-width: 475px;
  margin: 22px auto 0;
  color: var(--sub);
  font-size: 17px;
  line-height: 1.62;
  letter-spacing: -.012em;
  text-wrap: balance;
}

.product-detail-wrap {
  margin-top: clamp(32px, 6svh, 70px);
}

.before-after {
  position: relative;
  min-height: 493px;
  overflow: hidden;
  border-radius: 32px;
  background:
    radial-gradient(circle at 50% 49%, #fff0e2 0, transparent 21%),
    linear-gradient(140deg, #eff3fa, #fbfcff);
  border: 1px solid #e5e7ed;
}

.scattered {
  position: absolute;
  z-index: 3;
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 12px 14px;
  border: 1px solid rgba(255, 255, 255, .85);
  border-radius: 14px;
  background: rgba(255, 255, 255, .82);
  box-shadow: 0 16px 32px rgba(35, 43, 59, .1);
  color: #596578;
  font-size: 11px;
  font-weight: 650;
}

.scattered span {
  width: 14px;
  height: 14px;
  border-radius: 4px;
  background: linear-gradient(135deg, #ffb46a, #ff7200);
}

.scattered-one {
  top: 56px;
  left: 61px;
  transform: rotate(-7deg);
  animation: float-a 5.4s ease-in-out infinite;
}

.scattered-two {
  top: 66px;
  right: 65px;
  transform: rotate(6deg);
  animation: float-b 6.2s ease-in-out infinite;
}

.scattered-three {
  bottom: 76px;
  left: 60px;
  transform: rotate(5deg);
  animation: float-c 5.7s ease-in-out infinite;
}

.scattered-four {
  right: 54px;
  bottom: 54px;
  transform: rotate(-5deg);
  animation: float-d 6.4s ease-in-out infinite;
}

@keyframes float-a {
  50% {
    transform: translate(4px, -8px) rotate(-4deg);
  }
}

@keyframes float-b {
  50% {
    transform: translate(-4px, 7px) rotate(3deg);
  }
}

@keyframes float-c {
  50% {
    transform: translate(5px, 6px) rotate(2deg);
  }
}

@keyframes float-d {
  50% {
    transform: translate(-5px, -6px) rotate(-2deg);
  }
}

.merge-beam {
  position: absolute;
  z-index: 1;
  height: 1px;
  background: linear-gradient(
    90deg,
    rgba(255, 122, 0, .53),
    rgba(255, 122, 0, 0)
  );
  transform-origin: left;
}

.beam-one {
  top: 113px;
  left: 163px;
  width: 174px;
  transform: rotate(27deg);
}

.beam-two {
  top: 128px;
  right: 157px;
  width: 166px;
  transform: rotate(151deg);
}

.beam-three {
  bottom: 139px;
  left: 156px;
  width: 177px;
  transform: rotate(-26deg);
}

.beam-four {
  right: 147px;
  bottom: 105px;
  width: 170px;
  transform: rotate(206deg);
}

.single-record {
  position: absolute;
  z-index: 4;
  top: 50%;
  left: 50%;
  width: 284px;
  padding: 21px;
  border: 1px solid rgba(255, 255, 255, .95);
  border-radius: 19px;
  background: rgba(255, 255, 255, .95);
  box-shadow: 0 25px 59px rgba(30, 40, 59, .16);
  transform: translate(-50%, -50%);
}

.record-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 15px;
  border-bottom: 1px solid #e5e5ea;
  color: #273244;
  font-size: 11px;
  font-weight: 700;
}

.record-header span {
  display: flex;
  align-items: center;
  gap: 6px;
}

.record-header b {
  padding: 5px 7px;
  border-radius: 980px;
  background: #e8f8ed;
  color: #278843;
  font-size: 9px;
}

.record-title {
  padding: 16px 0 5px;
  color: #1d1d1f;
  font-size: 14px;
  font-weight: 700;
}

.record-data {
  display: flex;
  justify-content: space-between;
  padding-top: 11px;
  color: #86868b;
  font-size: 10px;
}

.record-data strong {
  color: #45454a;
  font-weight: 650;
}

.record-check {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 18px;
  padding: 9px;
  border-radius: 9px;
  background: #fff1e5;
  color: #b94f00;
  font-size: 10px;
  font-weight: 650;
}

/* ==============================
   品牌區塊
   ============================== */

.night-section {
  position: relative;
  min-height: clamp(440px, 80svh, 680px);
  display: grid;
  place-items: center;
  overflow: hidden;
  color: white;
}

.night-image {
  position: absolute;
  inset: 0;
  background:
    url('/manus-storage/tallarge-star-route_46d10687.jpg')
      center/cover no-repeat,
    radial-gradient(
      circle at 72% 21%,
      rgba(103, 155, 255, .28) 0 1px,
      transparent 2px
    ),
    linear-gradient(135deg, #081632 0%, #102e62 48%, #050d22 100%);
  transform: scale(1.02);
}

.night-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    rgba(2, 9, 24, .87),
    rgba(3, 12, 34, .45),
    rgba(2, 9, 24, .82)
  );
}

.night-content {
  position: relative;
  z-index: 2;
  text-align: center;
}

.night-overline {
  color: #ffbf82;
}

.night-content h2 {
  font-size: clamp(48px, 6vw, 82px);
}

.night-content h2 span {
  color: #ffb068;
}

.night-content > p {
  max-width: 460px;
  margin: 24px auto 0;
  color: rgba(255, 255, 255, .72);
  font-size: 17px;
  line-height: 1.65;
  letter-spacing: -.012em;
  text-wrap: balance;
}

.night-route {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: min(435px, 85vw);
  height: 46px;
  margin: 43px auto 0;
}

.night-route:before {
  content: "";
  position: absolute;
  right: 0;
  left: 0;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 183, 110, .8),
    transparent
  );
}

.night-route span {
  position: relative;
  z-index: 2;
  width: 9px;
  height: 9px;
  border: 2px solid #ffb16a;
  border-radius: 50%;
  background: #10254a;
  box-shadow: 0 0 0 6px rgba(255, 177, 106, .12);
}

.night-route i {
  position: absolute;
  z-index: 3;
  left: 58%;
  width: 30px;
  height: 30px;
  border-radius: 10px;
  background: white;
  box-shadow: 0 9px 23px rgba(0, 0, 0, .32);
  transform: translateX(-50%);
  animation: drive 4.8s ease-in-out infinite;
}

.night-route i:after {
  content: "🚚";
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  font-style: normal;
  font-size: 15px;
}

@keyframes drive {
  50% {
    left: 69%;
  }
}

.apple-button.light {
  background: #fff;
  color: #161616;
}

.apple-button.light:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, .22);
}

.apple-button.ghost {
  border: 1px solid rgba(255, 255, 255, .44);
  background: rgba(255, 255, 255, .04);
  color: #fff;
}

.apple-button.ghost:hover {
  background: rgba(255, 255, 255, .12);
}

/* ==============================
   頁尾
   ============================== */

.footer {
  padding: 28px 0;
  background: #061127;
  color: #aeb9cb;
}

.footer-inner {
  display: flex;
  align-items: center;
  gap: 17px;
}

.footer .brand-logo {
  width: 132px;
  max-height: 30px;
  filter: brightness(0) invert(1);
  opacity: .94;
}

.footer span {
  font-size: 11px;
}

.footer small {
  margin-left: auto;
  color: #73819a;
  font-size: 11px;
}

/* ==============================
   較窄畫面：展開式導覽列
   ============================== */

@media (max-width: 1100px) {
  .nav {
    gap: 16px;
  }

  .nav-actions {
    margin-left: auto;
  }

  .nav-links {
    position: absolute;
    top: 60px;
    right: 0;
    left: 0;
    display: none;
    flex-direction: column;
    align-items: stretch;
    gap: 0;
    margin-left: 0;
    padding: 10px 24px 16px;
    max-height: calc(100dvh - 60px);
    overflow-y: auto;
    background: rgba(255, 255, 255, .98);
    border-bottom: 1px solid #e5e5ea;
    box-shadow: 0 13px 26px rgba(0, 0, 0, .09);
  }

  .nav-links.open {
    display: flex;
  }

  .nav-links a {
    min-height: 48px;
    padding: 12px 0;
    font-size: 14px;
  }

  .nav-links a + a {
    border-top: 1px solid rgba(0, 0, 0, .045);
  }

  .nav-menu {
    display: inline-flex;
  }
}

/* ==============================
   平板
   ============================== */

@media (max-width: 1000px) {
  .management-grid {
    grid-template-columns: 1fr;
    gap: 45px;
  }

  .management-copy {
    max-width: 620px;
  }

  .product-stage {
    margin-top: 0;
  }

  .product-feature {
    transform: scale(.9);
  }

  .feature-0 {
    left: calc(50% - 330px);
  }

  .feature-1 {
    right: calc(50% - 330px);
  }

  .feature-2 {
    left: calc(50% - 330px);
  }

  .feature-3 {
    right: calc(50% - 330px);
  }
}

/* ==============================
   寬而矮的視窗
   同時判斷寬度、高度與長寬比
   ============================== */

@media
  (min-width: 621px) and
  (max-height: 740px) and
  (min-aspect-ratio: 3/2) {

  .hero-content {
    padding-top: 18px;
    padding-bottom: 16px;
  }

  .hero h1 {
    font-size: clamp(32px, 8svh, 60px);
  }

  .hero-actions {
    margin-top: 14px;
  }

  .hero-product {
    width: min(1480px, 100%);
    margin-top: 18px;
  }

  .scroll-link {
    margin-top: 12px;
  }

  .hero-showcase-layout {
    min-height: clamp(320px, 43svh, 420px);
  }

  .hero-device-tablet {
    top: clamp(120px, 19svh, 160px);
    left: clamp(24px, 8vw, 128px);
    width: min(42vw, 680px, calc(42svh * 1.7778));
  }

  .hero-device-tablet .tablet-screen-frame {
    width: 100%;
  }

  .hero-device-phone {
    top: clamp(24px, 4svh, 36px);
    right: clamp(80px, 10vw, 180px);
    width: min(100%, clamp(170px, min(16vw, 29svh), 250px));
  }

  .hero .phone-device {
    width: 100%;
  }

  .hero .showcase-route {
    height: 32px;
    margin-top: 0;
  }

  .hero .hero-product {
    margin-top: 0;
  }

  .hero .scroll-link {
    margin-top: 6px;
  }
}

/* ==============================
   手機
   高度不足時自然捲動
   ============================== */

@media (max-width: 620px) {
  .wrap {
    width: min(100% - 34px, 1180px);
  }

  .header {
    height: 56px;
  }

  .brand-logo {
    width: 132px;
    max-height: 32px;
  }

  .nav {
    gap: 10px;
  }

  .nav-actions {
    gap: 6px;
  }

  .nav-links {
    top: 56px;
    padding: 10px 17px 16px;
    max-height: calc(100dvh - 56px);
  }

  .language {
    display: none;
  }

  .nav-login {
    padding: 7px 10px;
    font-size: 11px;
  }

  .nav-menu {
    width: 36px;
    height: 40px;
  }

  .hero {
    min-height: calc(100svh - 56px);
  }

  .hero-content {
    padding-top: clamp(20px, 3.5svh, 36px);
    padding-bottom: 16px;
  }

  .hero h1 {
    font-size: clamp(30px, min(9vw, 7svh), 47px);
  }

  .hero-copy {
    max-width: 310px;
    margin-top: 18px;
    font-size: 16px;
  }

  .hero-product {
    margin-top: clamp(14px, 2svh, 20px);
  }

  .hero-showcase-layout {
    max-width: none;
    grid-template-columns: minmax(0, 1.65fr) minmax(96px, .75fr);
    grid-template-areas:
      "message message"
      "tablet phone";
    gap: clamp(18px, 2.6svh, 22px) clamp(8px, 3vw, 14px);
  }

  .hero-device-tablet .tablet-device {
    width: 100%;
    height: auto;
  }

  .hero-device-tablet .tablet-screen-frame {
    width: 100%;
    padding: 5px;
    border-radius: 12px;
  }

  .tablet-screen {
    border-radius: 6px;
  }

  .hero-device-phone .phone-device {
    width: min(100%, clamp(96px, 29vw, 138px));
    height: auto;
    aspect-ratio: 706 / 1466;
  }

  .hero-device-phone .phone-frame {
    padding: 4px;
    border-radius: 25px;
  }

  .hero-device-phone .phone-screen {
    border-radius: 20px;
  }

  .showcase-phone-island {
    top: 8px;
    height: 11px;
  }

  .showcase-route {
    width: 90%;
    height: 36px;
    margin-top: clamp(12px, 1.8svh, 17px);
  }

  .showcase-walker,
  .showcase-walker img {
    width: 38px;
    height: 38px;
  }

  .scroll-link {
    margin-top: 14px;
  }

  .management-copy > p:not(.overline) {
    font-size: 15px;
  }

  .management-copy h2 {
    font-size: clamp(42px, 12vw, 58px);
  }

  .management-copy .management-slogan {
    max-width: 300px;
    margin-top: 24px;
    font-size: 21px;
  }

  .product-stage {
    min-height: 682px;
    border-radius: 27px 27px 0 0;
  }

  .product-stage-glow {
    top: 164px;
    width: 330px;
    height: 330px;
  }

  .product-feature {
    top: auto;
    bottom: 23px;
    width: calc(50% - 22px);
    padding: 8px 9px;
    border-radius: 12px;
    transform: none;
  }

  .product-feature.active {
    background: rgba(255, 255, 255, .13);
  }

  .feature-icon {
    width: 31px;
    height: 31px;
    border-radius: 10px;
  }

  .feature-copy b {
    font-size: 10px;
  }

  .feature-copy small {
    display: none;
  }

  .feature-0 {
    left: 16px;
  }

  .feature-1 {
    right: 16px;
  }

  .feature-2 {
    bottom: 73px;
    left: 16px;
  }

  .feature-3 {
    right: 16px;
    bottom: 73px;
  }

  .phone-shell {
    width: 230px;
    height: 449px;
    bottom: 129px;
    border-width: 5px;
    border-radius: 35px;
  }

  .phone-island {
    top: 15px;
    width: 75px;
    height: 19px;
  }

  .phone-view {
    border-radius: 23px;
    padding: 0;
  }


  .product-intro > p:last-child {
    font-size: 15px;
  }

  .before-after {
    min-height: 390px;
    border-radius: 23px;
  }

  .scattered {
    padding: 8px 9px;
    font-size: 9px;
  }

  .scattered-one {
    top: 29px;
    left: 16px;
  }

  .scattered-two {
    top: 38px;
    right: 15px;
  }

  .scattered-three {
    bottom: 40px;
    left: 16px;
  }

  .scattered-four {
    right: 14px;
    bottom: 24px;
  }

  .beam-one {
    top: 82px;
    left: 80px;
    width: 105px;
  }

  .beam-two {
    top: 90px;
    right: 75px;
    width: 105px;
  }

  .beam-three {
    bottom: 83px;
    left: 76px;
    width: 107px;
  }

  .beam-four {
    right: 72px;
    bottom: 70px;
    width: 107px;
  }

  .single-record {
    width: 230px;
    padding: 16px;
  }

  .record-title {
    font-size: 12px;
  }

  .night-content h2 {
    font-size: 48px;
  }

  .night-content > p {
    max-width: 330px;
    font-size: 15px;
  }

  .night-actions {
    flex-direction: column;
    align-items: center;
  }

  .footer-inner {
    flex-wrap: wrap;
  }

  .footer .brand-logo {
    width: 120px;
    max-height: 28px;
  }

  .footer span {
    width: 100%;
  }

  .footer small {
    width: 100%;
    margin: 0;
  }
}

@media (max-width: 620px) and (max-height: 700px) {
  .hero-content {
    padding-top: clamp(16px, 3svh, 22px);
    padding-bottom: 12px;
  }

  .hero h1 {
    font-size: clamp(29px, min(8vw, 6svh), 40px);
  }

  .hero-actions {
    margin-top: 12px;
  }

  .hero-product {
    margin-top: 12px;
  }

  .hero-device-phone .phone-device {
    width: min(100%, clamp(96px, 26vw, 120px));
  }

  .showcase-route {
    height: 30px;
    margin-top: 10px;
  }

  .showcase-walker,
  .showcase-walker img {
    width: 34px;
    height: 34px;
  }

  .scroll-link {
    margin-top: 10px;
  }
}

/* 減少動態效果偏好 */

/* ==============================
   平板與小型平板 RWD 修正
   ============================== */
@media (min-width: 621px) and (max-width: 1000px) {
  .wrap {
    width: min(calc(100% - 48px), 900px);
  }

  .hero-content {
    padding-top: clamp(28px, 5vh, 52px);
    padding-bottom: 36px;
  }

  .hero-showcase-layout {
    width: 100%;
    max-width: 900px;
    grid-template-columns: minmax(0, 1fr) minmax(130px, .38fr);
    column-gap: clamp(16px, 3vw, 32px);
  }

  .hero-device-tablet,
  .hero-device-phone {
    min-width: 0;
  }

  .tablet-screen-frame {
    width: min(100%, 68vw, 740px);
  }

  .hero-device-phone .phone-device {
    width: min(100%, clamp(130px, 18vw, 184px));
  }

  .management-section,
  .product-section,
  .night-section {
    padding-top: clamp(64px, 9vh, 112px);
  }

  .management-grid {
    width: min(calc(100% - 48px), 760px);
    gap: 32px;
  }

  .management-copy h2 {
    font-size: clamp(44px, 7vw, 64px);
  }

  .management-copy .management-slogan {
    margin-top: 20px;
    font-size: clamp(21px, 3vw, 28px);
  }

  .product-stage {
    width: 100%;
    min-height: clamp(640px, 82vw, 700px);
    border-radius: clamp(24px, 4vw, 40px);
  }
}

/* 窄平板：將功能按鈕改為兩列，避免固定定位超出展示卡 */
@media (min-width: 621px) and (max-width: 760px) {
  .wrap {
    width: calc(100% - 36px);
  }

  .hero-showcase-layout {
    grid-template-columns: minmax(0, 1fr) minmax(112px, .34fr);
    column-gap: 12px;
  }

  .hero-device-phone .phone-device {
    width: min(100%, 150px);
  }

  .management-grid {
    width: calc(100% - 36px);
    gap: 28px;
  }

  .product-stage {
    min-height: 650px;
  }

  .product-feature {
    z-index: 6;
    width: calc(50% - 24px);
    padding: 8px;
    gap: 8px;
    transform: scale(.86);
  }

  .product-feature.active,
  .product-feature.active:hover {
    transform: scale(.86) translateY(-2px);
  }

  .feature-0 {
    top: 20px;
    left: 10px;
    right: auto;
    bottom: auto;
  }

  .feature-1 {
    top: 20px;
    right: 10px;
    left: auto;
    bottom: auto;
  }

  .feature-2 {
    top: 74px;
    left: 10px;
    right: auto;
    bottom: auto;
  }

  .feature-3 {
    top: 74px;
    right: 10px;
    left: auto;
    bottom: auto;
  }

  .phone-shell {
    top: 152px;
    bottom: auto;
    width: min(270px, 48vw);
    height: 480px;
  }
}

/* 平板橫放：解除桌機絕對定位，讓兩台裝置隨容器比例縮放 */
@media (min-width: 1001px) and (max-width: 1366px) and (orientation: landscape) {
  .hero {
    height: auto;
    min-height: calc(100svh - 60px);
  }

  .hero > .wrap.hero-content {
    display: block;
    width: calc(100% - 48px);
    height: auto;
    min-height: calc(100svh - 60px);
    padding-top: clamp(20px, 4svh, 38px);
    padding-bottom: 24px;
  }

  .hero-showcase-layout {
    display: grid;
    grid-template-columns: minmax(0, 1.65fr) minmax(112px, .75fr);
    grid-template-areas:
      "message message"
      "tablet phone";
    align-items: center;
    gap: clamp(18px, 3svh, 28px) clamp(14px, 2.5vw, 32px);
    width: 100%;
    height: auto;
    min-height: clamp(300px, 43svh, 410px);
    max-width: 1080px;
    margin: 0 auto;
  }

  .hero-message {
    position: relative;
    top: auto;
    left: auto;
    width: 100%;
    transform: none;
  }

  .hero h1 {
    font-size: clamp(36px, 5vw, 64px);
  }

  .hero-device-tablet,
  .hero-device-phone {
    position: relative;
    inset: auto;
    width: 100%;
    min-width: 0;
    align-self: center;
  }

  .hero-device-tablet .tablet-device {
    width: 100%;
    transform: none;
    animation: none;
    will-change: auto;
  }

  .hero-device-tablet .tablet-screen-frame {
    width: min(100%, 64vw, 740px, calc(42svh * 1.7778));
  }

  .hero-device-phone .phone-device {
    width: min(100%, clamp(112px, 14vw, 176px));
  }

  .hero-product {
    width: min(100%, 1080px);
    margin-top: clamp(14px, 2svh, 22px);
  }

  .showcase-route {
    width: calc(100% - 24px);
  }
}

/* 一頁主張＋四個獨立功能頁，內容先留白待討論 */
.feature-page {
  display: flex;
  align-items: center;
  min-height: 100svh;
  padding: clamp(72px, 10vh, 120px) 0;
}
.feature-intro-page {
  background: #fff;
  text-align: center;
}
.feature-page-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: clamp(28px, 6vh, 64px);
  width: min(1180px, calc(100% - 48px));
  min-height: inherit;
  margin: 0 auto;
}
.feature-intro-page .management-copy {
  max-width: 760px;
}
.feature-intro-page .management-copy h2 {
  font-size: clamp(48px, 7vw, 88px);
}
.feature-intro-page .management-slogan {
  margin: 28px auto 0;
  text-align: left;
}
.feature-detail-page {
  background: #fff;
}
.feature-detail-alt {
  background: #f7f8fa;
}
.feature-detail-layout {
  display: grid;
  grid-template-columns: minmax(240px, .72fr) minmax(0, 1.65fr);
  align-items: center;
  gap: clamp(42px, 7vw, 120px);
}
.feature-detail-layout.is-reversed {
  grid-template-columns: minmax(0, 1.65fr) minmax(240px, .72fr);
}
.feature-detail-layout.is-reversed .feature-detail-copy {
  grid-column: 2;
  grid-row: 1;
}
.feature-detail-layout.is-reversed .feature-page-visual {
  grid-column: 1;
  grid-row: 1;
}
.feature-detail-copy {
  position: relative;
  align-self: center;
  padding: 12px 0;
}
.feature-detail-page h2 {
  margin: 0;
  color: #111827;
  font-size: clamp(34px, 4.2vw, 62px);
  font-weight: 780;
  letter-spacing: -.075em;
  line-height: .98;
}
.feature-detail-copy p {
  max-width: 330px;
  margin: 28px 0 0;
  color: #667085;
  font-size: clamp(17px, 1.5vw, 21px);
  line-height: 1.75;
  letter-spacing: -.02em;
}
.feature-page-visual {
  width: 100%;
  max-width: none;
  height: auto;
  max-height: 66vh;
  object-fit: cover;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  display: block;
}
@media (max-width: 620px) {
  .management-cube {
    inset: -24%;
  }
  .management-cube-space {
    transform: rotateX(4deg) rotateY(-6deg);
  }
  .feature-page {
    min-height: 100svh;
    padding: 64px 0;
  }
  .feature-page-inner {
    width: calc(100% - 34px);
    gap: 28px;
  }
  .feature-intro-page .management-copy h2 {
    font-size: clamp(42px, 11vw, 62px);
  }
  .feature-intro-page .management-slogan {
    margin-top: 22px;
    font-size: clamp(20px, 5.5vw, 27px);
  }
  .feature-detail-layout,
  .feature-detail-layout.is-reversed {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 36px;
  }
  .feature-detail-layout.is-reversed .feature-detail-copy,
  .feature-detail-layout.is-reversed .feature-page-visual {
    grid-column: auto;
    grid-row: auto;
    order: initial;
  }
  .feature-detail-layout.is-reversed .feature-detail-copy {
    order: 0;
  }
  .feature-detail-layout.is-reversed .feature-page-visual {
    order: 1;
  }
  .feature-detail-copy {
    padding-bottom: 24px;
  }
  .feature-detail-page h2 {
    font-size: clamp(34px, 10vw, 48px);
  }
  .feature-detail-copy p {
    margin-top: 20px;
    font-size: 17px;
  }
  .feature-page-visual {
    max-height: none;
    border-radius: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  *,
  *:before,
  *:after {
    animation-duration: .001ms !important;
    transition-duration: .001ms !important;
    scroll-behavior: auto !important;
  }
}
`;
